import React, { useEffect, useState } from "react";
import {
  Modal,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

const AddUserModal = ({
  isOpen,
  toggle,
  onUsuarioAdicionado,
  usuarioEditavel,
}) => {
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");

  useEffect(() => {
    if (usuarioEditavel) {
      setNome(usuarioEditavel.nome);
      setTelefone(usuarioEditavel.telefone);
      setEmail(usuarioEditavel.email);
      setSenha(""); // Deixe a senha em branco ao editar
    } else {
      setNome("");
      setTelefone("");
      setEmail("");
      setSenha("");
    }
  }, [usuarioEditavel]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!nome || !telefone || !email || (!senha && !usuarioEditavel)) {
      onUsuarioAdicionado("Preencha todos os campos!", "error");
      return;
    }

    const novoUsuario = {
      nome,
      telefone,
      email,
      senha, // Use senha vazia ao editar caso o usuário não deseje mudar
    };

    const url = usuarioEditavel
      ? `${process.env.REACT_APP_API}/usuarios/${usuarioEditavel.id}`
      : `${process.env.REACT_APP_API}/register `;
    const method = usuarioEditavel ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(novoUsuario),
      });
      const data = await response.json();
      if (data.error) {
        onUsuarioAdicionado(data.message, "error");
      } else {
        onUsuarioAdicionado(
          "Usuário adicionado/atualizado com sucesso!",
          "success"
        );
        toggle();
      }
    } catch (error) {
      console.error("Erro ao adicionar/editar usuário:", error);
      onUsuarioAdicionado("Erro ao adicionar/editar usuário!", "error");
    }
  };

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">
          {usuarioEditavel ? "Editar Usuário" : "Adicionar Usuário"}
        </h5>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={toggle}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="modal-body">
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label for="nome">Nome</Label>
                <Input
                  type="text"
                  name="nome"
                  id="nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  required
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="telefone">Telefone</Label>
                <Input
                  type="text"
                  name="telefone"
                  id="telefone"
                  value={telefone}
                  onChange={(e) => setTelefone(e.target.value)}
                  required
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="senha">Senha</Label>
                <Input
                  type="password"
                  name="senha"
                  id="senha"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required={!usuarioEditavel} // Senha é obrigatória apenas ao adicionar um novo usuário
                />
              </FormGroup>
            </Col>
          </Row>
        </div>

        <div className="modal-footer">
          <Button type="button" color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button type="submit" color="primary">
            Salvar
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddUserModal;
